"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LoadingPage;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const NavBar_1 = __importDefault(require("../NavBar"));
const material_1 = require("@mui/material");
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const SkeletonTableRow_1 = __importDefault(require("./SkeletonTableRow"));
const StyledTableContainer = (0, styles_1.withStyles)(() => ({
    root: {
        boxShadow: 'none',
    },
}))(TableContainer_1.default);
const useStyles = (0, styles_1.makeStyles)({
    table: {
        margin: 24,
    },
    header: {
        margin: 24,
    },
});
function LoadingPage({}) {
    const classes = useStyles();
    const rows = Array.from(Array(20), (_, i) => (react_1.default.createElement(SkeletonTableRow_1.default, { key: i })));
    return (react_1.default.createElement(NavBar_1.default, { disabled: true },
        react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement("br", null),
            react_1.default.createElement(material_1.Skeleton, { width: "20%", "data-testid": "SkeletonLoading" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(material_1.Skeleton, { width: "10%" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(material_1.Skeleton, { width: "100%" })),
        react_1.default.createElement(StyledTableContainer, null,
            react_1.default.createElement(Table_1.default, { className: classes.table },
                react_1.default.createElement(TableBody_1.default, null, rows)))));
}
